/* The Rest product page (v32): bundle tiles, photo carousel, sticky bar. */
(function(){
  document.querySelectorAll('.v32').forEach(function(root){
  var R=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(s){return Array.prototype.slice.call(root.querySelectorAll(s))}
  var qty=root.querySelector('[data-v32-qty]');
  function setB(r){
    var t=r.getAttribute('data-total'),w=r.getAttribute('data-was'),s=r.getAttribute('data-save');
    if(qty)qty.value=r.value;
    all('[data-v32-total]').forEach(function(e){e.textContent=t});
    all('[data-v32-label]').forEach(function(e){e.textContent=r.getAttribute('data-label')});
    all('[data-v32-was]').forEach(function(e){e.textContent=w;e.hidden=!w});
    all('[data-v32-save]').forEach(function(e){e.textContent=s;e.hidden=!s});
    all('.v32-bopt').forEach(function(l){l.classList.toggle('is-on',l.querySelector('input')===r)});
  }
  all('.v32-bopt input').forEach(function(r){r.addEventListener('change',function(){if(r.checked)setB(r)})});

  var tr=root.querySelector('[data-v32-track]');
  if(tr){
    var n=tr.children.length,cur=0,raf,dots=root.querySelector('[data-v32-dots]');
    if(dots&&n>1){for(var i=0;i<n;i++){var b=document.createElement('button');b.type='button';b.className='v32-dot';b.setAttribute('data-v32-go',i);b.setAttribute('aria-label','Show photo '+(i+1));dots.appendChild(b)}}
    var mark=function(i){cur=i;all('[data-v32-go]').forEach(function(b){b.setAttribute('aria-current',+b.getAttribute('data-v32-go')===i?'true':'false')})};
    var go=function(i){i=Math.max(0,Math.min(n-1,i));tr.scrollTo({left:i*tr.clientWidth,behavior:R?'auto':'smooth'});mark(i)};
    tr.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){mark(Math.round(tr.scrollLeft/tr.clientWidth))})},{passive:true});
    root.addEventListener('click',function(e){
      var g=e.target.closest('[data-v32-go]');if(g){go(+g.getAttribute('data-v32-go'));return}
      var s=e.target.closest('[data-v32-step]');if(s){go(cur+ +s.getAttribute('data-v32-step'))}
    });
    tr.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(cur+1)}else if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1)}});
    window.addEventListener('resize',function(){tr.scrollLeft=cur*tr.clientWidth});
    mark(0);
  }

  var st=root.querySelector('[data-v32-sticky]'),atc=root.querySelector('.v32-buy .product-form__submit');
  if(st&&atc){
    var badge=function(){var b=document.getElementById('shop-hcaptcha-badge-container');st.classList.toggle('has-badge',!!(b&&b.getBoundingClientRect().width>0))};
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){badge();st.classList.toggle('is-show',!es[0].isIntersecting&&es[0].boundingClientRect.top<0)}).observe(atc)}
    else{st.classList.add('is-show')}
  }
  });
})();